import { render } from "./MenuLateral.vue?vue&type=template&id=064c1b54&scoped=true"
import script from "./MenuLateral.vue?vue&type=script&lang=js"
export * from "./MenuLateral.vue?vue&type=script&lang=js"

import "./MenuLateral.vue?vue&type=style&index=0&id=064c1b54&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-064c1b54"],['__file',"src/common/MenuLateral/MenuLateral.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "064c1b54"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('064c1b54', __exports__)) {
    api.reload('064c1b54', __exports__)
  }
  
  module.hot.accept("./MenuLateral.vue?vue&type=template&id=064c1b54&scoped=true", () => {
    api.rerender('064c1b54', render)
  })

}


export default __exports__